(function () {
  var beans = Array.prototype.slice.call(document.querySelectorAll('.coffee-bean'));
  if (beans.length) {
    var ticking = false;
    var moveBeans = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      beans.forEach(function (bean, index) {
        var speed = Number(bean.getAttribute('data-speed') || 2);
        var offset = y / speed;
        var rotate = (index % 2 === 0 ? 28 : -34) + offset / 18;
        bean.style.transform = 'translate3d(0,' + (-offset) + 'px,0) rotate(' + rotate + 'deg)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(moveBeans);
        ticking = true;
      }
    }, { passive: true });
    moveBeans();
  }

  var progress = document.querySelector('[data-cart-progress]');
  if (progress) {
    var goal = Number(progress.getAttribute('data-goal') || 0);
    var total = Number(progress.getAttribute('data-total') || 0);
    var bar = progress.querySelector('.shipping-progress__bar span');
    var label = progress.querySelector('.shipping-progress__top strong');
    var percentLabel = progress.querySelector('.shipping-progress__top span');
    var formatMoney = function (cents) {
      try {
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
      } catch (e) {
        return '$' + Math.round(cents / 100).toLocaleString('es-CL');
      }
    };
    var percent = goal > 0 ? Math.min(100, Math.round((total / goal) * 100)) : 0;
    if (bar) bar.style.width = percent + '%';
    if (percentLabel) percentLabel.textContent = percent + '%';
    if (label && goal > total) label.textContent = 'Te faltan ' + formatMoney(goal - total) + ' para envio gratis';
  }
})();
